import { TrendingUpIcon } from 'lucide-react';

import { useTranslation } from '@splitfiesta/i18n';
import type { GroupWithDashboard } from '@splitfiesta/shared';
import { StatCard } from '@splitfiesta/ui';

import { CurrencyDisplay } from '@/components/ui/CurrencyDisplay';

interface TotalExpensesCardProps {
  group: GroupWithDashboard;
  totalSpent: number;
}

export function TotalExpensesCard({
  group,
  totalSpent,
}: TotalExpensesCardProps) {
  const { t } = useTranslation();

  return (
    <div data-testid="total-expenses-card">
      <StatCard
        icon={<TrendingUpIcon className="w-8 h-8" />}
        iconColor="text-gray-400"
        label={t('groups:stats.totalExpenses')}
        value={
          totalSpent === 0 ? (
            <>
              <div className="text-xl font-bold text-gray-900 dark:text-white">
                {t('groups:stats.noneExpenses')}
              </div>
              <div className="text-xs text-gray-500 dark:text-gray-400">
                {t('groups:stats.noExpenses')}
              </div>
            </>
          ) : (
            <>
              <div className="text-xl font-bold text-gray-900 dark:text-white">
                <CurrencyDisplay
                  amount={totalSpent}
                  currency={group?.currency || 'USD'}
                />
              </div>
              <div className="text-xs text-gray-500 dark:text-gray-400">
                {group?.currency || 'USD'}
              </div>
            </>
          )
        }
      />
    </div>
  );
}
